/**
 * Detect consumer Google mailboxes so we can nudge OAuth instead of password signup.
 * googlemail.com is the legacy Gmail domain (same accounts).
 */
export function isGoogleMailAddress(email: string): boolean {
  const normalized = email.trim().toLowerCase();
  if (!normalized.includes("@")) return false;
  // Require a plausible local-part so we don't flash on half-typed "@gmail"
  const at = normalized.lastIndexOf("@");
  if (at <= 0) return false;
  const domain = normalized.slice(at + 1);
  return domain === "gmail.com" || domain === "googlemail.com";
}
